export class DeviceParamLirisV2 {


    public paramA: number;
    public paramB: number;
    public paramC: number;
    public trigger: number;

}